import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import ImgLazyLoad from "../../ImgLazyLoad";

interface WarrantiesProps {}

interface InjectedProps extends WarrantiesProps {
  homePageStore: HomePageStore;
}
const warranties: React.SFC<WarrantiesProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  const { warranties, warrantyTitle } = homePageStore.homePageContent.response;
  return (
    <div className="subaru_warranty">
      <ul className="subaru_warranty_items desktop">
        <li>{!!warrantyTitle ? warrantyTitle : "WARRANTIES"}</li>
        {warranties.map((item, i) => {
          return (
            <li className="warranty_icon" key={`desktop_${i}`}>
              <ImgLazyLoad src={item.iconUrl} />
              {item.desktopTitle}
            </li>
          );
        })}
      </ul>

      <ul className="subaru_warranty_items mobile">
        <li>{!!warrantyTitle ? warrantyTitle : "WARRANTIES"}</li>
        {warranties.map((item, i) => {
          return (
            <li className="warranty_icon" key={`mobile_${i}`}>
              <ImgLazyLoad src={item.iconUrl} />
              {item.mobileTitle}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default inject("homePageStore")(observer(warranties));
